import { ROUTES } from '@/router/routesEnum';
import tblUpdateDocument, { TblUpdateDocument } from '@/shared/model/tblUpdateDocument';
import { CompletedInfo } from '@/shared/model/tblUpdateSupplier';
import { OdataItems } from '@/shared/model/OdataItems';
import { SearchParams } from '@/shared/model/searchParams';
import { CONST } from '@/shared/utils/Constants';
import Vue from 'vue';
import DateUtils from '@/shared/utils/DateUtils';
import { Contact } from '@/shared/model/contact';
import { Component, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import GeneralUtils from '@/shared/utils/generalUtils';
import D4yTable from '@/components/d4y-table/d4y-table.vue';
import DateField from '@/components/_common/date-field/DateField.vue';
import searchData from '@/shared/model/smallPayloadModels/searchData';
import { TblUpdateCondition } from '@/shared/model/tblUpdateCondition';

const name = 'tblUpdateDocuments-view';
const contactModule = namespace('contact');
const tblUpdateDocumentModule = namespace('tblUpdateDocument');
const tblUpdateSupplierModule = namespace('tblUpdateSupplier');
const tblUpdateConditionModule = namespace('tblUpdateCondition');
const authModule = namespace('auth');

@Component({ name: name, components: { D4yTable, DateField } })
export default class TblUpdateDocumentsComponent extends Vue {
  @tblUpdateDocumentModule.Action('getTblUpdateDocuments')
  private actionGettblUpdateDocuments!: any;
  @tblUpdateDocumentModule.Action('getDocumentCategoryList')
  private actionGetDocumentCategoryList!: any;
  @tblUpdateDocumentModule.Getter('getTblUpdateDocuments')
  private tblUpdateDocuments!: OdataItems<TblUpdateDocument>;
  @tblUpdateDocumentModule.Getter('getTblUpdateDocumentsSearchParams')
  private tblUpdateDocumentsSearchParams!: SearchParams;
  @tblUpdateDocumentModule.Getter('getTblUpdateDocumentsIsLoading')
  private tblUpdateDocumentsIsLoading!: boolean;
  @tblUpdateDocumentModule.Getter('getTblUpdateDocumentrsTotal')
  private tblUpdateDocumentrsTotal!: number;
  @tblUpdateDocumentModule.Action('deleteTblUpdateDocument')
  private actionDeleteTblUpdateDocument!: any;
  @tblUpdateDocumentModule.Action('getAddDocumentCompleted')
  private actionAddDocumentCompleted!: any;
  @tblUpdateConditionModule.Action('updateDashboardDate')
  private actionUpdateConditionDashboardDate!: any;
  @tblUpdateSupplierModule.Action('updateDashboardDate')
  private actionUpdateDashboardDate!: any;
  @tblUpdateDocumentModule.Action('updateDashboardDate')
  private actionUpdateDocumentDashboardDate!: any;

  @tblUpdateDocumentModule.Getter('getDashboardDate')
  private dashboardDate!: any;
  @contactModule.Getter('getContactForLoggedInUser')
  private contactForLoggedInUser!: Contact;

  @tblUpdateDocumentModule.Action('updateDashboardDocumentsStatus')
  private actionGetDashboardDocumentsStatus!: any;
  @tblUpdateDocumentModule.Getter('getDashboadrdDocumentsStatus')
  private dashboardDocumentsStatus!: any;
  @tblUpdateDocumentModule.Action('getCanselDocumentCompleted')
  private actionCanselDocumentCompleted!: any;

  @authModule.Getter('azureUser')
  private azureUser!: any;
  @authModule.Getter('azureUserEmail')
  private azureEmail!: any;
  private selectedStatus: string = '';
  docCategory = [];
  docCategoryList = [];
  private isLoadingFilters: any = {
    category: false,
  };
  // state snapshots (store information about the conditions under which the list was last loaded)
  private lastFetchSnapshots: any = {
    category: null as string | null,
  };

  dateSearch: any = '';
  documentType: any = '';
  private searchTerm = '';

  @Watch('tblUpdateDocumentsSearchParams.filter', { deep: true })
  public async onOptionsFilterChanged(newValFilter: string, oldValFilter: string) {
    if (newValFilter == oldValFilter) {
      return;
    }
    this.tblUpdateDocumentsSearchParams.dataOption.page = 1;
    this.actionGettblUpdateDocuments({
      searchParams: this.tblUpdateDocumentsSearchParams,
      documentSearchData: {
        datum: this.dateSearch,
        searchTerm: this.searchTerm,
        documentType: this.documentType,
        contactEmail: this.azureEmail,
        statusDocument: this.selectedStatus,
      },
    });
  }

  changeDate(value: any) {
    // prevent strange 2 request with the same value
    if (this.dateSearch == value) {
      return;
    }
    this.dateSearch = value || undefined; // new Date(value).toJSON();

    this.actionGettblUpdateDocuments({
      searchParams: this.tblUpdateDocumentsSearchParams,
      documentSearchData: {
        datum: this.dateSearch,
        searchTerm: this.searchTerm,
        documentType: this.documentType,
        contactEmail: this.azureEmail,
        statusDocument: this.selectedStatus,
      },
    });
    this.actionUpdateConditionDashboardDate(value);
    this.actionUpdateDashboardDate(value);
    this.actionUpdateDocumentDashboardDate(value);
  }

  created() {
    if (this.$route.fullPath.includes('/tasks/werbung')) {
      this.documentType = 'werbung';
    } else {
      this.documentType = '';
    }
    if (this.dashboardDate) {
      this.dateSearch = this.dashboardDate;
    }

    if (this.dashboardDocumentsStatus) {
      this.selectedStatus = this.dashboardDocumentsStatus;
    } else {
      this.selectedStatus = 'all';
    }
  }

  isInitialRequest = true;
  async mounted() {
    var promiseAll = [this.getDocumentCategoryList(), this.getTblUpdateDocuments()];
    await Promise.all(promiseAll);
    this.isInitialRequest = false;
  }

  private async getDocumentCategoryList() {
    await this.actionGetDocumentCategoryList({
      documentSearchData: {
        datum: this.dateSearch,
        searchTerm: this.searchTerm,
        documentType: this.documentType,
        contactEmail: this.azureEmail,
        statusDocument: this.selectedStatus,
      },
    })
      .then((result: any) => {
        this.docCategoryList = result;
      })
      .catch((err: any) => {})
      .finally(() => {
        this.isLoadingFilters['category'] = false;
      });
  }

  private async getTblUpdateDocuments() {
    await this.actionGettblUpdateDocuments({
      searchParams: this.tblUpdateDocumentsSearchParams,
      documentSearchData: {
        datum: this.dateSearch,
        searchTerm: this.searchTerm,
        documentType: this.documentType,
        contactEmail: this.azureEmail,
        documentCategory: this.docCategory,
        statusDocument: this.selectedStatus,
      },
    });
  }

  get headers() {
    let headers: {
      text: string | any;
      value: string;
      sortable?: boolean;
      width?: string;
      align?: string;
    }[] = [
      {
        text: this.$t(''),
        value: 'data-table-select',
        sortable: false,
      },
      { text: this.$t('updated_on'), value: 'doc_changedate', width: '170px' },
      { text: this.$t('doc_name'), value: 'doc_name' },
      { text: this.$t('document_path'), value: 'doc_path' },
      { text: this.$t('document_created_on'), value: 'doc_erstellt_von' },
      { text: this.$t('document_category'), value: 'doc_category' },
      { text: this.$t('documents_list_completed'), value: 'documentDoneTimeCompleted' },
      {
        text: this.$t('actions'),
        value: 'actions',
        sortable: false,
        width: '1%',
        align: 'center',
      },
    ];
    return headers;
  }

  get image() {
    return {};
    return {
      src: 'img_tblUpdateSupplier.png',
      header: this.$t('title'),
      width: 360,
      height: 200,
    };
  }

  onAdd() {
    this.add();
  }

  add() {
    // this.$router.push({
    //   name: ROUTES.tblUpdateSupplier,
    //   params: {
    //     tblUpdateSupplierId: CONST.emptyGuid,
    //   },
    // });
  }

  get isRealXl() {
    return this.$vuetify.breakpoint.width < 1920;
  }

  get getFilterFields() {
    return this.tblUpdateDocumentsSearchParams.orClauseFieldsIds
      .map((x) => this.$t(GeneralUtils.camelToSnakeCase(x)))
      .toString();
  }

  private async tblUpdateDocumentsUpdateOptions(newVal: any, oldVal: any) {
    this.tblUpdateDocumentsSearchParams.dataOption = newVal;
    // `oldVal` is always `undefined`
    if (newVal != oldVal && this.tblUpdateDocumentsIsLoading != undefined && !this.isInitialRequest)
      this.getTblUpdateDocuments();
  }

  deleteTblUpdateDocument(editedTblUpdateDocument: TblUpdateDocument) {
    return;
    this.$confirm
      .open(`${this.$t('delete_dialog_title')}`, `${this.$t('delete_dialog_text')}`, {
        cancelText: this.$t('delete_dialog_cancel'),
        okText: this.$t('delete_dialog_ok'),
      })
      .then(async (response: any) => {
        if (response) {
          await this.actionDeleteTblUpdateDocument(editedTblUpdateDocument.id).then(() => {
            this.getTblUpdateDocuments();
          });
        }
      });
  }

  private async completedDocument(tblUpdateDocument: any) {
    if (tblUpdateDocument.documentDoneTimeCompleted.length == 0) {
      this.actionAddDocumentCompleted({
        id: tblUpdateDocument.id,
        zrMaster: this.contactForLoggedInUser ? this.contactForLoggedInUser?.zrMaster : null,
        contactEmail: this.azureEmail,
      }).then((completedInfo: CompletedInfo) => {
        tblUpdateDocument.documentDoneTimeCompleted = completedInfo.completedDoneTime;
        tblUpdateDocument.documentUserNameCompleted = completedInfo.completedUserName;
        this.getTblUpdateDocuments();
      });
    } else {
      this.$confirm
        .open(`${this.$t('completed_dialog_title')}`, `${this.$t('completed_dialog_title_text')}`, {
          cancelText: this.$t('delete_dialog_cancel'),
          okText: this.$t('delete_dialog_ok'),
        })
        .then(async (response: any) => {
          if (response) {
            this.actionCanselDocumentCompleted({
              id: tblUpdateDocument.id,
              zrMaster: this.contactForLoggedInUser ? this.contactForLoggedInUser?.zrMaster : null,
              contactEmail: this.azureEmail,
            }).then((completedInfo: CompletedInfo) => {
              tblUpdateDocument.documentDoneTimeCompleted = '';
              tblUpdateDocument.documentUserNameCompleted = '';
              this.getTblUpdateDocuments();
            });
          }
        });
    }
  }

  get title() {
    if (this.$route.fullPath.includes('/tasks/werbung')) {
      return this.$t('titleWerbung');
    } else {
      return this.$t('title');
    }
  }

  changeSelectStatus() {
    this.getTblUpdateDocuments();
  }

  changeDocumentCategory() {
    this.getTblUpdateDocuments();
  }

  get labelTitel() {
    if (this.$route.fullPath.includes('/suppliers')) {
      return this.$t('supplier_status');
    } else {
      return this.$t('employee_status');
    }
  }

  closeDocuments() {
    this.tblUpdateDocumentsSearchParams.filter = '';
    this.$router.push({
      name: ROUTES.tasks,
    });
  }

  openDocuments(item: TblUpdateDocument) {
    let url: any = 'https://einrichtungspartnerringvme.sharepoint.com/' + item.doc_path_full;
    window.open(item.doc_path_full, '_blank');
  }

  private changeSearch(searchTerm: string) {
    if (searchTerm.length < 2) return;
    this.tblUpdateDocumentsSearchParams.dataOption.page = 1;
    this.getTblUpdateDocuments();
  }
  private changeSearchInput(value: string) {
    if (value == null || value.length == 0) {
      this.resetSearch();
    }
  }
  private resetSearch() {
    this.searchTerm = '';
    this.tblUpdateDocumentsSearchParams.dataOption.page = 1;
    this.getTblUpdateDocuments();
  }

  get titleSearch() {
    if (this.$route.fullPath.includes('/tasks/werbung')) {
      return this.$t('search_Werbung');
    } else {
      return this.$t('search_Document');
    }
  }

  activeState = [
    {
      text: this.$i18n.t(`select_all`), //'Alle',
      value: 'all',
    },
    {
      text: this.$i18n.t(`select_offen`), //'Offen',
      value: 'open',
    },
    {
      text: this.$i18n.t(`select_erledigt`), //'Erledigt',
      value: 'done',
    },
  ];

  private selection?: {
    showSelect: boolean;
    singleSelect?: boolean;
    customHeader?: boolean;
  } = { showSelect: true };

  selected: TblUpdateCondition[] = [];
  get isCompleted() {
    return this.selected?.length > 0;
  }

  enterSelect(values: any) {
    if (values?.length > 0) {
      this.selected = values;
    } else {
      this.selected = [];
    }
  }

  completedFiles() {
    this.selected.forEach((item: any) => {
      if (item.documentDoneTimeCompleted.length == 0) {
        this.actionAddDocumentCompleted({
          id: item.id,
          zrMaster: this.contactForLoggedInUser ? this.contactForLoggedInUser?.zrMaster : null,
          contactEmail: this.azureEmail,
        });
      }
    });
    this.selected = [];
    setTimeout(() => {
      this.getTblUpdateDocuments();
    }, 500);
  }

  getDependencySnapshot(excludeFilterName: 'category'): string {
    const state = {
      date: this.dateSearch,
      searchTerm: this.searchTerm,
      status: this.selectedStatus,
      category: excludeFilterName === 'category' ? [] : [...this.docCategory].sort(),
    };
    return JSON.stringify(state);
  }

  async onFocusFilter(filterName: 'category') {
    // ds, 13.05.2026 -> creating a snapshot of the current dependencies
    const currentSnapshot = this.getDependencySnapshot(filterName);

    // ds, 13.05.2026 -> if the snapshot hasn't changed since the last download, exit; no request is needed
    if (this.lastFetchSnapshots[filterName] === currentSnapshot) {
      return;
    }

    this.isLoadingFilters[filterName] = true;

    try {
      // ds, 13.05.2026 -> update only the list that the user has currently opened

      if (filterName === 'category') {
        this.getDocumentCategoryList();
      }

      // ds, 13.05.2026 -> save the new snapshot
      this.lastFetchSnapshots[filterName] = currentSnapshot;
    } catch (error) {}
  }
}
